export const NOTIFICATIONS_QUERY_KEYS = {
  all: ["NOTIFICATIONS"] as const,
  list: (offset?: number, limit?: number) =>
    [...NOTIFICATIONS_QUERY_KEYS.all, "LIST", offset, limit] as const,
  unseenCount: () => [...NOTIFICATIONS_QUERY_KEYS.all, "UNSEEN_COUNT"] as const,
} as const;
